import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { DsoDashboardView } from '../components/ar/DsoDashboardView';
import { PageHead } from '../components/layout';
import { useActiveCompanyId, useDsoDashboard } from '../lib/queries';

export const Route = createFileRoute('/ar/dso')({ component: ArDsoPage });

export function ArDsoPage() {
  const navigate = useNavigate();
  const companyId = useActiveCompanyId();
  const { data, isPending, error } = useDsoDashboard(companyId);

  return (
    <div className="page">
      <PageHead
        crumbs={['ลูกหนี้การค้า', 'DSO / KPI']}
        title="ระยะเวลาเก็บหนี้ (DSO Dashboard)"
        actions={
          <button className="btn" onClick={() => void navigate({ to: '/ar' })}>
            ← กลับลูกหนี้การค้า
          </button>
        }
      />
      {isPending && (
        <div className="muted" style={{ padding: 24, textAlign: 'center' }}>
          กำลังโหลด…
        </div>
      )}
      {error && (
        <div className="neg" style={{ padding: 24, textAlign: 'center' }}>
          โหลดไม่สำเร็จ: {error.message}
        </div>
      )}
      {data && (
        <DsoDashboardView
          data={data}
          onOpenCustomer={(customerId) =>
            void navigate({ to: '/ar/statement/$customerId', params: { customerId } })
          }
        />
      )}
    </div>
  );
}
